<template src="../templates/newBooking.html"></template>
<script>
    import ContactModel from "../models/contactModel";
    import BookingModel from "../models/bookingModel";
    import JobsCollection from "../collections/jobsCollection";

    export default {
        name: 'Booking',
        data() {
            return {
                bookingModel: new BookingModel(),
                jobsCollection: new JobsCollection(),
                jobsData: [],
                previousFormVisible: false,
                dialogFormVisible: false,
                currentRow: null,
                total: 0,
                pageSize: 7,
                currentPage: 1,
                rules: {
                    senderName: [
                        {required: true, message: "Please input Sender's name", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: "Please input email", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'},
                        {type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change']}
                    ],
                    mobile: [
                        {required: true, message: "Please input mobile", trigger: 'blur'},
                        {type: 'number', message: 'mobile must be a number'}
                    ],
                    phone: [
                        {type: 'number', message: 'phone must be a number', trigger: 'blur'}
                    ],
                    startTime: [
                        {required: true, message: "Please input start time", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ],
                    endTime: [
                        {required: true, message: "Please input end time", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ],
                    serviceDate: [
                        {required: true, message: "Please input service date", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ],
                    language: [
                        {required: true, message: "Please input language", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ],
                    address: [
                        {required: true, message: "Please input address", trigger: 'blur'},
                        {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            loadDetails: function () {
                this.contactModel = new ContactModel();
                let url = this.$localApiURL + this.contactModel.getRoute("fetch");
                this.contactModel.fetch({
                    'url': url,
                    params: {token: localStorage.getItem('jwt')}
                }).then().catch((error) => {
                    console.error(error);
                });
            },
            handleCurrentChange(val) {
                this.currentRow = val;
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.paginate();
            },
            paginate: function () {

                let filteredData = this.jobsCollection.models;
                this.total = filteredData.length;
                if (this.total < this.pageSize) {
                    this.currentPage = 1;
                }
                this.jobsData = filteredData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);

            },
            loadPreviousJobs: function () {

                this.previousFormVisible = true;
                this.jobsCollection = new JobsCollection();
                let url = this.$localApiURL + this.jobsCollection.getRoute("fetchLatest");
                this.jobsCollection.fetch({
                    'url': url,
                    params: {
                        token: localStorage.getItem('jwt')
                    }
                }).then((result) => {

                        this.jobsData = result;
                        this.paginate();
                    }
                ).catch((error) => {
                    this.previousFormVisible = false;
                    console.error(error);
                });
            },
            chooseRecord: function () {
                this.bookingModel = this.currentRow;
                this.previousFormVisible = false;
            },
            removeDomain(item) {
                let index = this.bookingModel.nebs.indexOf(item);
                if (index !== -1) {
                    this.bookingModel.nebs.splice(index, 1);
                }
            }
            ,
            addDomain() {

                this.bookingModel.nebs.push({
                    key: Math.random().toString(36).substr(2, 9),
                    value: '',
                    name: "",
                    reference: "",
                    gender: ""
                });
            },

            showPreview() {
                this.bookingModel.validate();
                // if (this.bookingModel.errors.length == 0) {
                this.dialogFormVisible = true;
                // }
            },
            hidePreview() {
                this.dialogFormVisible = false;
            },
            bookJob() {
                this.$refs["bookingModel"].validate((valid) => {
                    if (valid) {
                        let url = this.$localApiURL + this.bookingModel.getRoute("save");
                        this.bookingModel.save({
                            'url': url,
                            params: {token: localStorage.getItem('jwt'), data: this.bookingModel}
                        }).then().catch(function (error) {
                            console.error(error);
                        });
                    }
                });
            }
        },
        created: function () {
            this.loadDetails();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/BookingComponent.vue